import React, { useEffect } from 'react';
import styles from '../../static/styles/UnsubscribeModal.module.css';

const UnsubscribeModal = ({ isOpen, onClose, onConfirm }) => {

    // close on ESC (production-level UX)
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div
                className={styles.modal}
                onClick={(e) => e.stopPropagation()}
            >
                {/* ICON */}
                <div className={styles.iconWrapper}>
                    <div className={styles.icon}>!</div>
                </div>

                {/* TEXT */}
                <div className={styles.subTitle}>CONFIRM ACTION</div>
                <div className={styles.title}>UNSUBSCRIBE?</div>

                <div className={styles.desc}>
                    Are you sure. You want to unsubscribe?
                </div>

                {/* LIST */}
                {/* <div className={styles.list}>
                    <div>✕ 1.25× Earn rate multiplier</div>
                    <div>✕ Free tournament entry</div>
                    <div>✕ Premium portal access</div>
                </div> */}

                {/* ACTIONS */}
                <div className={styles.actions}>
                    <button className={styles.keep} onClick={onClose}>
                        KEEP EARNING
                    </button>

                    <button className={styles.unsubscribe} onClick={onConfirm}>
                        UNSUBSCRIBE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnsubscribeModal;